import * as Yup from "yup";

export const schemaPaymentsDetails = Yup.object().shape({
  fullName: Yup.string().min(3).required("Full name is a required field"),
  address: Yup.string().required("Address is a required field"),
  city: Yup.string().required("City is a required field"),
  zip: Yup.string()
    .matches(/^[0-9]+$/, "Zip code must be only numbers")
    .min(5, "Zip code must be at least 5 characters")
    .max(5, "Zip code must be at most 5 characters")
    .required("Zip code is a required field"),
  state: Yup.string().required("State is a required field"),
  phone: Yup.string()
    .min(13, "Phone field is wrong")
    .max(15, "Phone field is wrong")
    .required("Phone is a required field"),
  email: Yup.string()
    .email("Field email is wrong")
    .required("Email is a required field"),
});
